module.exports = __webpack_public_path__ + "media/fonts/icomoon/fonts/icomoon-e5dfb05c0dbcfcbfa2e684617a8120f4.svg";